export default "__VITE_ASSET__DTveHGMg__"